import DiscordIcon from "@/assets/icons/brand/discord.svg";
import WechatIcon from "@/assets/icons/brand/wechat.svg";
import { DISCORD_INVITE_URL } from "@/common/const";
import { Button } from "@/component/Button";
import { Popover } from "antd";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import styles from "../index.module.css";

export const SocialButtons: React.FC = () => (
  <div className="flex items-center gap-2 sm:gap-3">
    <Popover
      trigger={["click", "hover"]}
      placement="bottom"
      arrow={false}
      classNames={{
        root: "!pt-2",
        body: classNames(
          "!p-6 !pb-[22px] flex bg-background-card! !rounded-xl !w-[198px]",
          styles.popoverBody
        ),
      }}
      content={
        <div className="text-text-primary text-sm font-normal rounded-none flex flex-col items-center">
          <Image
            src="/wechat-qrcode-260105.jpg"
            alt="Wechat QR Code"
            width={150}
            height={150}
            className="w-full h-auto"
          />
          <p className="mt-3 text-center">
            Welcome to join our WeChat community
          </p>
        </div>
      }
    >
      <Button
        type="plain"
        className="flex items-center justify-center border border-solid border-text-primary/[.07] rounded-full bg-black/20 backdrop-blur-xl transition-all hover:bg-primary/[.15] hover:backdrop-blur-none !cursor-default w-10 h-10"
        icon={<WechatIcon className="text-text-primary! w-4 sm:w-[18px]" />}
        aria-label="Wechat"
      ></Button>
    </Popover>

    <Link
      href={DISCORD_INVITE_URL}
      target="_blank"
      aria-label="Discord"
      className="text-text-primary!"
    >
      <div className="flex items-center justify-center border border-solid border-text-primary/[.07] rounded-full bg-black/20 backdrop-blur-xl transition-all hover:bg-primary/[.15] hover:backdrop-blur-none w-10 h-10">
        <DiscordIcon className="flex-shrink-0 w-4 sm:w-[18px]" />
      </div>
    </Link>
  </div>
);
